import {gql} from '@apollo/client';

const getBusPartnerAndCountryCostEntriesQuery = gql`
  query getBusPartnerAndCountryCostEntriesQuery(
    $countryId: ID!
    $busPartnerId: ID!
    $year: Int!
  ) {
    getBusPartnerCostEntryYear(busPartnerId: $busPartnerId, year: $year) {
      year
      qualityChecked
      busCostEntry {
        adblueCost
        cleaningCost
        currency
        dieselCost
        legalCost
        lngCost
        otherCost
        overheadCost
        repairCostPerDistanceUnit
        repairCostPerMonth
        tiresCost
        year
      }
      busTypeCostEntries {
        id
        year
        busTypeId
        leasingCost
        interestCost
        insuranceCost
        motorVehicleTax
        maintenanceCostPerMonth
        maintenanceCostPerDistanceUnit
        vehicleRegistrationCost
        customIdentifier
        vehicleProductionYear
        busType {
          adblueConsumption
          dieselConsumption
          doubleDecker
          fuelType
          id
          lngConsumption
          name
          numberOfTires
        }
      }
      driverCostEntry {
        year
        daytimeWeekdaysWorkingHourCost
        daytimeWeekendsWorkingHourCost
        nighttimeWeekdaysWorkingHourCost
        nighttimeWeekendsWorkingHourCost
        replacementCostPerKm
        replacementCostPerHr
        accommodationCostPerNight
      }
    }

    countryCostEntry(countryId: $countryId, year: $year) {
      year
      qualityChecked
      busCostEntry {
        adblueCost
        cleaningCost
        currency
        dieselCost
        flixStandardCost
        legalCost
        lngCost
        otherCost
        overheadCost
        repairCostPerDistanceUnit
        repairCostPerMonth
        tiresCost
        year
      }
      busTypeCostEntries {
        id
        year
        busTypeId
        leasingCost
        interestCost
        insuranceCost
        motorVehicleTax
        maintenanceCostPerMonth
        maintenanceCostPerDistanceUnit
        vehicleRegistrationCost
        customIdentifier
        vehicleProductionYear
        busType {
          adblueConsumption
          dieselConsumption
          doubleDecker
          fuelType
          id
          lngConsumption
          name
          numberOfTires
        }
      }
      driverCostEntry {
        year
        daytimeWeekdaysWorkingHourCost
        daytimeWeekendsWorkingHourCost
        nighttimeWeekdaysWorkingHourCost
        nighttimeWeekendsWorkingHourCost
        replacementCostPerKm
        replacementCostPerHr
        accommodationCostPerNight
        dailyAllowance
        prefilledEmptyDistance
        prefilledEmptyHr
      }
    }
  }
`;

export default getBusPartnerAndCountryCostEntriesQuery;
